module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui/~/babel-runtime/core-js/is-iterable.js
 ** module id = 960
 ** module chunks = 3
 **/